module.exports = __webpack_public_path__ + "img/r1-1.caeb9b4c.jpg";